class BazaarVoice extends HTMLElement {
  constructor () {
    super()

    this.checkModalReviewOpen()
    this.setStyle()
    this.updateAda()
    const observer = new window.MutationObserver((mutations) => {
      if (mutations.length) {
        this.getDataBV()
        observer.disconnect()
      }
    })
    observer.observe(this, { childList: true, subtree: true })
  }

  setStyle () {
    const reviewInlineEls = document.querySelectorAll('.js-review-inline')

    reviewInlineEls.forEach(reviewInlineEl => {
      const setStylingStars = () => {
        setTimeout(() => {
          const starIcons = reviewInlineEl.querySelectorAll('[data-bv-show="inline_rating"] linearGradient')
          if (starIcons.length) {
            starIcons.forEach(star => {
              const breakpoint = star.getAttribute('x1')
              if (breakpoint === '0%') return

              star.setAttribute('x1', '0%')
              star.setAttribute('x2', '100%')
              star.setAttribute('y1', '0%')
              star.setAttribute('y2', '0%')
              const stopLast = star.querySelector('stop:last-child')
              if (!stopLast) return
              stopLast.classList.add('last')
              stopLast.setAttribute('offset', breakpoint)

              const newStopLast = document.createElementNS('http://www.w3.org/2000/svg', 'stop')
              newStopLast.setAttribute('offset', breakpoint)
              newStopLast.setAttribute('style', stopLast.getAttribute('style'))
              star.appendChild(newStopLast)

              const newStopLast2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop')
              newStopLast2.setAttribute('offset', '100%')
              newStopLast2.setAttribute('style', stopLast.getAttribute('style'))
              star.appendChild(newStopLast2)
            })

            const reviewLink = reviewInlineEl.querySelector('a.bv_main_container')
            if (reviewLink) {
              reviewLink.href = '#reviews'
            }

            const reviewCountEl = reviewInlineEl.querySelector('.bv_numReviews_component_container .bv_text')
            if (!reviewCountEl) return

            const reviewContent = reviewCountEl.textContent.trim();
            const reviewCount = parseInt(reviewContent.replace(/[()]/g, ''), 10);

            if (!isNaN(reviewCount)) {
              const reviewText = reviewCount === 1 ? 'Review' : 'Reviews';
              reviewCountEl.textContent = `(${reviewCount} ${reviewText})`;
            }
          }
        }, 1000)
      }
      setStylingStars()
      const observerChild = new MutationObserver((mutations) => {
        if (mutations.length) {
          for (const mutation of mutations) {
            if (mutation.type === 'childList') {
              setStylingStars()
              observerChild.disconnect()
            }
          }
        }
      }, {});
      observerChild.observe(reviewInlineEl, { attributes: true, childList: true, subtree: true })
    })
  }

  checkModalReviewOpen () {
    const body = document.body
    const observer = new MutationObserver((mutations) => {
      if (mutations.length) {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            const modalEl = document.querySelector('#bv-mboxzone-lightbox')
            const placeholderEl = document.querySelector('.bv-content-placeholder')
            if (modalEl) {
              body.classList.add('overflow-hidden')
            } else {
              body.classList.remove('overflow-hidden')
            }

            if (placeholderEl) {
              body.classList.add('no-reviews')
            }
          }
        }
      }
    }, {});
    observer.observe(body, { attributes: true, childList: true, subtree: true })
  }

  updateAda () {
    const body = document.body
    const observer = new MutationObserver((mutations) => {
      if (mutations.length) {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            const buttonPreviousEl = document.querySelector('.bv-content-pagination-buttons-item-previous')
            const buttonNextEl = document.querySelector('.bv-content-pagination-buttons-item-next')
            if (buttonPreviousEl) {
              const buttonPrevEl = buttonPreviousEl.querySelector('[disabled]')
              if (buttonPrevEl) buttonPrevEl.setAttribute('aria-label', 'Previous Reviews')
            }
            if (buttonNextEl) {
              const buttonEl = buttonNextEl.querySelector('[disabled]')
              if (buttonEl) buttonEl.setAttribute('aria-label', 'Next Reviews')
            }
          }
        }
      }
    }, {});
    observer.observe(body, { attributes: true, childList: true, subtree: true })
  }

  getDataBV () {
    const accordionReview = document.querySelector('.js-accordion-review')
    const accordionReviewItem = document.querySelector('.js-accordion-review-product')
    const bvList = document.querySelectorAll('.bv-content-list > li')
    const content = accordionReview.closest('.js-content.is-open')
    if (accordionReview && bvList.length) {
      let html = ''
      bvList.forEach((bvItem, index) => {
        html += index < 3 ? bvItem.outerHTML : ''
      })
      accordionReview.innerHTML = html
    }
    if (accordionReviewItem && content) {
      content.style.maxHeight = content.children[0].scrollHeight + 'px'
    }
  }
}

customElements.define('bazaar-voice', BazaarVoice)
